import React from 'react';

const ServiceEndNotice: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '10px',
      background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
      fontFamily: '"Noto Sans KR", -apple-system, Roboto, Helvetica, sans-serif'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '20px',
        padding: '30px',
        maxWidth: '600px',
        textAlign: 'center',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
        lineHeight: '1.8'
      }}>
        
        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: '#333',
          marginBottom: '30px'
        }}>
          서비스 종료 안내
        </h1>
        
        <div style={{
          fontSize: '16px',
          color: '#555',
          marginBottom: '30px'
        }}>
          <p>그동안 본 사이트를 이용해주신 <br/>학우분들께 깊이 감사드립니다.</p>
          
          <p><strong>2025년 8월 29일</strong>부로<br/> 본 서비스는 종료되었습니다.</p>
          
          <p>이번 프로젝트를 계기로<br/>인제대학교 본관과의 협의를 거쳐<br/>통학 버스 시스템이<br/>새로운 방식으로 개선되었습니다.</p>
          
          <p>비록 최종 시스템은<br/>저희가 직접 만든 것은 아니지만,<br/>변화의 계기를 마련할 수 있어서<br/>다행이라고 생각합니다.</p>
          
          <p>앞으로도 여러분의 불편함을 해결할 수 있는<br/>더 나은 방법을 찾기 위해 노력하겠습니다.</p>
        </div>
        
        <div style={{
          borderTop: '2px solid #eee',
          paddingTop: '20px',
          fontSize: '14px',
          color: '#777'
        }}>
          <p>다시 한번 깊이 사과드리며, <br/>그동안의 관심과 사랑에 감사드립니다.</p>
          <p style={{ marginTop: '15px' }}>
            <strong>2025.08.26</strong><br/>
            인제대학교 컴퓨터공학과 학술동아리<br/>
            <strong>메가브레인 팀장 서상혁</strong>
          </p>
        </div>
        
        <div style={{
          marginTop: '30px',
          paddingTop: '20px',
          borderTop: '1px solid #eee'
        }}>
          <button
            onClick={() => window.open('https://bus.inje.ac.kr', 'blank')}
            style={{
              backgroundColor: '#2c3e50',
              color: 'white',
              border: 'none',
              padding: '15px 30px',
              fontSize: '16px',
              fontWeight: '600',
              borderRadius: '25px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(44, 62, 80, 0.3)',
              fontFamily: 'inherit'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#34495e';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(44, 62, 80, 0.4)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#2c3e50';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(44, 62, 80, 0.3)';
            }}
          >
            개선된 공식 서비스 이용하기
          </button>
          <p style={{
            fontSize: '12px',
            color: '#999',
            marginTop: '10px'
          }}>
            인제대학교 공식 통학 버스 시스템으로 이동합니다
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServiceEndNotice;
